export default __webpack_public_path__ + "static/media/graySnapchat.d4089605.svg";